<template>
  <el-table-column
    :width="field.width"
    :sortable="field.sortable ? 'custom' : false"
    :label="field.label"
    :prop="field.prop"
    :key="field.prop"
  >
    <template slot-scope="scope" class="pull-right">
      <img :src="src(scope)" class="thumbnail" />
    </template>
  </el-table-column>
</template>

<script>
import { get } from 'lodash'

export default {
  props: ['field'],
  computed: {
    src() {
      return scope => get(scope.row, this.field.prop)
    }
  }
}
</script>

<style lang="scss" scoped>
.thumbnail {
  max-width: 120px;
}
</style>
